import Flickity from "react-flickity-component";
import React, { useState } from "react";
import styled from "styled-components";

import Button from "./Button";

const StyledFlickity = styled(Flickity)`
  & .flickity-button {
    height: 20px;
    width: 20px;
    background: none;
    color: white;
  }
`;

const Hero = styled.div`
  position: relative;
  margin-bottom: 20px;
  width: 100%;
  color: white;
`;

const HeroOverlay = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > * {
    margin: 0;
    position: relative;
    z-index: 2;
  }

  & h3 {
    font-weight: bold;
    font-size: 13px;
  }

  & p {
    font-size: 12px;
    line-height: 14px;
  }

  &:after {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 80px;
    content: "";
    background: linear-gradient(
      0deg,
      rgba(0, 0, 0, 0.9) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  }
`;

const Slide = styled.div`
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  display: flex;
  justifty-content: center;
  align-items: cetner;

  & img {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
    height: 100%;
    width: 100%;
  }
`;

const Popup = styled.div`
  position: absolute;
  width: 100%;
  left: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const PopupContent = styled.div`
  position: relative;
  margin: 20px;
  background: white;
  width: 100%;
  max-width: 440px;
  padding: 20px;

  & h3 {
    font-size: 16px;
  }
`;

const PopupClose = styled.button`
  position: absolute;
  right: 3px;
  top: 3px;
  width: 13px;
  height: 13px;
  opacity: 0.8;
  padding: 0;
  background: 0;
  &:hover {
    opacity: 1;
  }

  &:before,
  &:after {
    position: absolute;
    left: 7px;
    content: " ";
    height: 13px;
    width: 1.5px;
    top: 0;
    background-color: #000;
  }

  &:before {
    transform: rotate(45deg);
  }

  &:after {
    transform: rotate(-45deg);
  }
`;
const PopupTrigger = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  margin-left: 10px;
  height: 15px;
  width: 15px;
  color: white;
  border: 1px solid white;
  font-size: 10px;

  &:hover {
    background: white;
    color: black;
  }
`;

const StyledButton = styled(Button)`
  display: block;
  margin: 15px auto 0;
  padding: 3px 5px;
  min-width: 125px;
  text-transform: none;
  color: ${(props) => (props.active ? "white" : "black")};
  background: ${(props) =>
    props.active ? "var(--colour-tertiary-dmn)" : "transparent"};
  border-color: ${(props) =>
    props.active ? "var(--colour-tertiary-dmn)" : "black"};
`;

const PackageHero = ({ data, active, click }) => {
  const {
    title,
    subtitle,
    desktopImageUrl1,
    desktopImageUrl2,
    desktopImageUrl3,
    popupImageUrl,
    popupText,
    popupTitle,
  } = data;
  const [popupOpen, setPopupOpen] = useState(false);

  return (
    <>
      <Hero>
        <StyledFlickity options={{ pageDots: false }}>
          <Slide>
            <img src={desktopImageUrl1 !== null ? desktopImageUrl1 : "https://www.youngs.co.uk/youngs/uploads/sites/2/2021/07/square.jpg"} />
          </Slide>
          {desktopImageUrl2 && (
            <Slide>
              <img src={desktopImageUrl2} />
            </Slide>
          )}
          {desktopImageUrl3 && (
            <Slide>
              <img src={desktopImageUrl3} />
            </Slide>
          )}
        </StyledFlickity>
        <HeroOverlay>
          <div>
            {title && <h3>{title}</h3>}
            {subtitle && <p>{subtitle}</p>}
          </div>
          {popupTitle && (
            <PopupTrigger onClick={() => setPopupOpen(true)}>i</PopupTrigger>
          )}
        </HeroOverlay>
      </Hero>
      {popupOpen && (
        <Popup>
          <PopupContent>
            <PopupClose onClick={() => setPopupOpen(false)} />
            <img style={{width: '100%'}} src={popupImageUrl} />
            <h3>{popupTitle}</h3>
            <p>{popupText}</p>
            <StyledButton active={active} onClick={() => click(data)}>
              {active ? "Selected" : "Select"}
            </StyledButton>
          </PopupContent>
        </Popup>
      )}
    </>
  );
};

export default PackageHero;
